<template>
    <div>
        <b-row class="mb-4">
            <b-col cols="12" md="3">
                <label>{{ $t('Type of Certificate') }} <span class="text-danger">*</span></label>
            </b-col>
            <b-col sm="12" md="9">
                <NewDocOption 
                    :data="doc_type_list"
                    :ref="'doc_type'"
                    @selected-document="selectedDocumentBeneficiary($event)">
                </NewDocOption>
                <div v-if="error['beneficiaryIdType']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryIdType'])}}
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col cols="12" md="3">
                <label>{{ $t('ID Photo') }} <span class="text-danger">*</span></label>
            </b-col>

            <b-col sm="12" md="3">
                <div class="d-flex justify-content-center">
                    <label class="pt-2">{{ $t('ID Photo Front Side') }} <span class="text-danger">*</span></label>
                    <span class="position-relative">
                        <button type="button" class="flat-button position-absolute" @click="togglePopup(1)">
                        <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                        </button>
                        <NewPopupInfo :name="(params.beneficiaryIdType==1 || params.beneficiaryIdType==3 || params.beneficiaryIdType==4?'ic':'passport')+'_front'" v-if="showPopup_1" :addClass="'popup-info-center'"></NewPopupInfo>
                    </span>
                </div>

                <FileUploader  
                    :type="'browse'"
                    :ref="'beneficiaryIdFront'"
                    :allowed_types = "['jpg','jpeg', 'png']"
                    :size="4*1024*1024"
                    @capture-file="captureFile($event,'beneficiaryIdFront')" 
                    @remove-image="removeImage($event,'beneficiaryIdFront')"
                    @toggle-camera="toggleCamera($event)">
                </FileUploader>
                <div v-if="error['beneficiaryIdFront']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryIdFront'])}}
                </div>
            </b-col>
            
            <b-col sm="12" md="3" v-if="params.beneficiaryIdType==1 || params.beneficiaryIdType == 3 || params.beneficiaryIdType == 4">
                <div class="d-flex justify-content-center">
                    <label class="pt-2">{{ $t('ID Photo Back Side') }} <span class="text-danger">*</span></label>
                    <span class="position-relative">
                        <button type="button" class="flat-button position-absolute" @click="togglePopup(2)">
                        <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                        </button>
                        <NewPopupInfo :name="(params.beneficiaryIdType==1 || params.beneficiaryIdType==3 || params.beneficiaryIdType==4?'ic':'passport')+'_national'" v-if="showPopup_2" :addClass="'popup-info-center'"></NewPopupInfo>
                    </span>
                </div>
                <FileUploader  
                    :type="'browse'"
                    :ref="'beneficiaryIdReverse'"
                    :allowed_types = "['jpg','jpeg', 'png']"
                    :size="4*1024*1024"
                    @capture-file="captureFile($event,'beneficiaryIdReverse')" 
                    @remove-image="removeImage($event,'beneficiaryIdReverse')">
                </FileUploader>
                <div v-if="error['beneficiaryIdReverse']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryIdReverse'])}}
                </div>
            </b-col>
        </b-row>


        <b-row class="mb-3">
            <b-col cols="12" md="3">
                <label>{{ $t('ID Number') }} <span class="text-danger">*</span></label>
            </b-col>

            <b-col sm="12" md="9">
                <input type="text" class="form-control" :placeholder="$t('ID Number')" v-model="params.beneficiaryIdNo" @keydown="onChange('beneficiaryIdNo')"/>
                <div v-if="error['beneficiaryIdNo']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryIdNo'])}}
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col cols="12" md="3">
                <label>{{ $t('Beneficiary Name') }} <span class="text-danger">*</span></label>
            </b-col>

            <b-col sm="12" md="9">
                <input type="text" class="form-control" :placeholder="$t('Name')" v-model="params.beneficiaryName" @keydown="onChange('beneficiaryName')"/>
                <div v-if="error['beneficiaryName']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryName'])}}
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col cols="12" md="3">
                <label>{{ $t('Date of Birth') }} <span class="text-danger">*</span></label>
            </b-col>

            <b-col sm="12" md="9">
                <date-picker v-model="params.beneficiaryBirthDate" :lang="lang_date" input-class="form-control" format="YYYY-MM-DD" value-type="YYYY-MM-DD" @change="onChange('beneficiaryBirthDate')"></date-picker>
                <div v-if="error['beneficiaryBirthDate']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryBirthDate'])}}
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col cols="12" md="3">
                <label>{{ $t('Certificate Validity') }} <span class="text-danger">*</span></label>
            </b-col>

            <b-col sm="12" md="9">
                <date-picker v-model="params.beneficiaryCertExpiryDate" :lang="lang_date" input-class="form-control" format="YYYY-MM-DD" value-type="YYYY-MM-DD" @change="onChange('beneficiaryCertExpiryDate')"></date-picker>
                <div v-if="error['beneficiaryCertExpiryDate']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryCertExpiryDate'])}}
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col xl="4" sm="12">
                <div class="form-group mb-0">
                    <label>{{ $t('Province') }} <span class="text-danger">*</span></label>
                    <Select2 v-model="params.beneficiaryProvince" :options="provinceOpt" @select="onSelectProvince($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Province")}' class="form-control"/>
                    <div v-if="error['beneficiaryProvince']" class="invalid-feedback d-block mb-3">
                        {{$t(error['beneficiaryProvince'])}}
                    </div>
                </div>
            </b-col>
            <b-col xl="4" sm="12">
                <div class="form-group mb-0">
                    <label>{{ $t('City') }} <span class="text-danger">*</span></label>
                    <Select2 v-model="params.beneficiaryCity" :options="cityOpt" @select="onSelectCity($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("City")}' class="form-control"/>
                    <div v-if="error['beneficiaryCity']" class="invalid-feedback d-block mb-3">
                        {{$t(error['beneficiaryCity'])}}
                    </div>
                </div>
            </b-col>
            <b-col xl="4" sm="12">
                <div class="form-group mb-0">
                    <label>{{ $t('District') }}</label>
                    <Select2 v-model="params.beneficiaryArea" :options="districtOpt" @select="onSelectDistrict($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("District")}' class="form-control"/>
                    <div v-if="error['beneficiaryArea']" class="invalid-feedback d-block mb-3">
                        {{$t(error['beneficiaryArea'])}}
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col xl="12">
                <div class="form-group mb-0">
                    <label>{{ $t('permanent address (detailed address)') }} <span class="text-danger">*</span></label>
                    <input type="text" name="beneficiaryAddress" v-model="params.beneficiaryAddress" class="form-control" @keydown="addressCondition($event)" @keyup="onchangeAddress($event)"/>
                    <div v-if="error['beneficiaryAddress']" class="invalid-feedback d-block mb-3">
                        {{$t(error['beneficiaryAddress'])}}
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col cols="12">
                <label>{{ $t('Holdings ratio (%)') }} <span class="text-danger">*</span></label>
                <MaskAmount @set-price="changePrice($event)" :bus="beneficiaryShareholderRatio" ref="beneficiaryShareholderRatio"></MaskAmount>
                <div v-if="error['beneficiaryShareholderRatio']" class="invalid-feedback d-block mb-3">
                    {{$t(error['beneficiaryShareholderRatio'])}}
                </div>
            </b-col>
        </b-row>
    </div>


</template>

<script>
import Vue from "vue";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Select2 from 'v-select2-component';

import NewDocOption from "@/components/Kyc/NewDocOption";
import FileUploader from '@/components/Kyc/FileUploader.vue';
import NewPopupInfo from '@/components/NewPopupInfo.vue';
import CreateAccount from '@/services/CreateAccount';
import MaskAmount from "@/components/Mask/MaskAmount";

import 'vue2-datepicker/locale/zh-cn';
import 'vue2-datepicker/locale/zh-tw';
import 'vue2-datepicker/locale/ja';
import 'vue2-datepicker/locale/en';

export default {
  data() {
    return {
        publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        showPopup_1:false,
        showPopup_2:false,
        showPopup_3:false,
        cityOpt:[],
        districtOpt:[],
        provinceOpt:[],
        lang_date:'en',
        maxSize:4,
        success:null,
        userNo:null,
        accountId:null,
        optional:['beneficiaryArea'],
        beneficiaryShareholderRatio:new Vue(),
        file:{
            beneficiaryIdFront:null,
            beneficiaryIdReverse:null
        },
        params:{
            // nationality:'',
            beneficiaryIdType:'',
            beneficiaryIdFront:'',
            beneficiaryIdReverse:'',
            beneficiaryIdNo:'',
            beneficiaryName:'',
            beneficiaryBirthDate:'',
            beneficiaryCertExpiryDate:'',
            beneficiaryProvince:'',
            beneficiaryCity:'',
            beneficiaryArea:'',
            beneficiaryAddress:'',
            beneficiaryShareholderRatio:''
        },
        error:{
            // nationality:'',
            beneficiaryIdType:'',
            beneficiaryIdFront:'',
            beneficiaryIdReverse:'',
            beneficiaryIdNo:'',
            beneficiaryName:'',
            beneficiaryBirthDate:'',
            beneficiaryCertExpiryDate:'',
            beneficiaryProvince:'',
            beneficiaryCity:'',
            beneficiaryArea:'',
            beneficiaryAddress:'',
            beneficiaryShareholderRatio:''
        }
    }
  },
  components:{
    NewDocOption,
    FileUploader,
    Select2,
    NewPopupInfo,
    DatePicker,
    MaskAmount
  },
  props:['doc_type_list','information','user_no','account_id','index','country'],
  methods:{
    changePrice(event){
        this.error.beneficiaryShareholderRatio = '';
        this.params.beneficiaryShareholderRatio = event;
    },
    getFile(index,file_id){
        let self = this;
        CreateAccount.getFile({fileId:file_id}).then(response => {
            let data_file = response.data.data[0];
            
            if(data_file.type == 2 || data_file.type == 5){
                self.params.beneficiaryIdFront = data_file.file;
                self.$refs['beneficiaryIdFront'].image = data_file.file;
            }
            else if(data_file.type == 3){
                self.params.beneficiaryIdReverse = data_file.file;
                self.$refs['beneficiaryIdReverse'].image = data_file.file;
            }
        });
    },
    addressCondition($event){
        if($event.keyCode == 13){
            $event.preventDefault();
        }
        this.onChange('beneficiaryAddress');
    },
    onchangeAddress($event){
        let msg = $event.target.value.replace("\n", " ");
        $event.target.value = msg;
    },
    onSelectDistrict({id,text}){
        var self = this;
        this.onChange('beneficiaryArea');
    },
    onSelectCity({id,text,code}){
        var self = this;
        this.onChange('beneficiaryCity');
        if(text){
            this.beneficiaryArea="";
        }
        this.getDistrict(code);
    },
    onSelectProvince({id,text,code}){
        var self = this;
        this.onChange('beneficiaryProvince');
        self.districtOpt = [];
        if(text){
            this.beneficiaryCity = "";
            this.beneficiaryArea = "";
        }
        this.getCity(code);
    },
    getDistrict(code){
        this.districtOpt = [];
        CreateAccount.getDistrict({"city_id":code}).then(response => {
            const data = response.data.data;
            data.forEach(item => {
                this.districtOpt.push({"id":item.value,"text":item.text,"code":item.code});
            });
        }).catch(err => {
            this.checkError(err);
        });
    },
    getCity(code){
        this.cityOpt = [];
        CreateAccount.getCity({"province_id":code}).then(response => {
            const data = response.data.data;
            data.forEach(item => {
                this.cityOpt.push({"id":item.value,"text":item.text,"code":item.code});
            });
        }).catch(err => {
            this.checkError(err);
        });
    },
    onChange(name){
        this.error[name]="";
    },
    validate(){
        let success = true;
        let self = this;
        Object.keys(this.params).forEach(function(key) {
            if(self.params.beneficiaryIdType==2 && key == "beneficiaryIdReverse"){
                self.error[key]="";
            }
            else if((self.params[key]=='' || self.params[key]==null)&& !self.optional.includes(key)){
                self.error[key]="can not be blank.";
                success = false;
            }
        });

        return success;
    },
    uploadFile(account_id,user_no){
        let self = this;
        this.success = null;
        this.accountId = account_id;
        this.userNo = user_no;
        
        this.error.beneficiaryIdFront='';
        this.error.beneficiaryIdReverse='';
        
        let fileList = [
            {
                "type":(self.params.beneficiaryIdType==1 || self.params.beneficiaryIdType==3 || self.params.beneficiaryIdType == 4)?2:5,
                "maxSize":self.maxSize*1024*1024,
                "file":self.params.beneficiaryIdFront
            }
        ];

        if(self.params.beneficiaryIdType==1 || self.params.beneficiaryIdType==3 || self.params.beneficiaryIdType == 4){
            fileList.push(
                {
                    "type":3,
                    "maxSize":self.maxSize*1024*1024,
                    "file":self.params.beneficiaryIdReverse
                }
            );
        }

        CreateAccount.uploadFile({
            "accountId":self.accountId,
            "userNo":""+self.userNo,
            "fileUpload":fileList
        }).then(response => {
            const data = response.data.data;
            let fileList = data["file"];
            for(let i=0;i<fileList.length;i++){
                if(fileList[i].type==2 || fileList[i].type==5){
                    // self.params.beneficiaryIdFront = fileList[i].file;
                    self.file.beneficiaryIdFront = fileList[i].fileId;
                }
                else if(fileList[i].type==3){
                    // self.params.beneficiaryIdReverse = fileList[i].file;
                    self.file.beneficiaryIdReverse = fileList[i].fileId;
                }
            }
            self.success = true;
            self.$emit('file-uploaded');
        }).catch(err => {
            self.checkError(err);
        });
    },
    checkError(err){
        try{
            let self = this;
            const response = err.response;  
            if(response.status == 400){
                if(typeof response.data.message === 'string'){
                    this.$notify({
                        type: 'warn',
                        text: response.data.message
                    });
                }
                else{
                    if(response.data.message['file']){
                        let fileList = response.data.message['file'];
                        for(let i=0;i<fileList.length;i++){
                            if(fileList[i].type==2 || fileList[i].type==5){
                                self.error.beneficiaryIdFront=fileList[i].message;
                            }
                            else if(fileList[i].type==3){
                                self.error.beneficiaryIdReverse=fileList[i].message;
                            }
                        }
                    }
                    self.success = false;
                    self.$emit('file-uploaded');
                }
            }      
            else if(response.status == 401 && response.data.name == "Unauthorized"){
                    localStorage.removeItem("token");
                    localStorage.removeItem("member");
                    localStorage.removeItem("isFirstTime");
                    this.$router.push({ 
                        path: '/login', 
                    });
            }
            else{
                if(localStorage.getItem("token")){
                    var msg = (response.data)?response.data.message:err.message;
                    this.$notify({
                        type: 'warn',
                        text: msg
                    })
                }
            }
        }catch(e){
            console.log(err);
        }
    },
    togglePopup(index){
        this['showPopup_'+index]=!this['showPopup_'+index];
    },
    selectedDocumentBeneficiary(data){
        this.params.beneficiaryIdType = data;
        this.error.beneficiaryIdType = "";
    },
    captureFile($event,key) {
        this.error[key] = "";
        this.params[key] = $event;
    },
    removeImage($event,key){
        this.error[key] = "";
    },
    doEscapeMarkup(markup){
        return markup;
    }
  },
  mounted(){
    let self = this;
    this.$nextTick(() => {
    
        CreateAccount.getProvince({"country":this.country}).then(response => {
            const data = response.data.data;
            this.provinceOpt = [];
            data.forEach(item => {
                this.provinceOpt.push({"id":item.value,"text":item.text,"code":item.id});    
            });
            
            if(this.information){
                 
                Object.keys(this.params).forEach(function(key) {
                    if(typeof self.file[key]!=="undefined" && self.information[key] && self.information[key][self.index]){
                        self.file[key]=self.information[key][self.index];
                        self.getFile(key,self.information[key][self.index]);
                    }
                    else if(typeof self.params[key] !== 'undefined' && self.information[key]) {
                        self.params[key]=self.information[key][self.index];
                    }
                });

                if(self.params.beneficiaryShareholderRatio){
                    this.$refs['beneficiaryShareholderRatio'].init(self.params.beneficiaryShareholderRatio);
                }

                if(self.information['beneficiaryIdType']){
                    self.$refs['doc_type'].doc_type = parseInt(self.information['beneficiaryIdType'][self.index]);
                }
                else{
                    self.$refs['doc_type'].doc_type = '';
                }
                
                if(this.params.beneficiaryProvince){
                    let data_province = this.params.beneficiaryProvince.split("_");
                    this.getCity(data_province[0]);
                }
                
                if(this.params.beneficiaryCity){
                    let data_city = this.params.beneficiaryCity.split("_");
                    this.getDistrict(data_city[0]);
                }
            }

            if(this.user_no){
                this.userNo = this.user_no;
                this.accountId = this.account_id;
            }

        }).catch(err => {
            this.checkError(err);
        });
    });
  }
}
</script>